<template>
    <div>
        <!-- 发票头 -->
        <invoice-header
        :ref="('invoiceHeaderTable_'+ uuid)"
        :invoiceHeaderData="invoiceData"
        @invoiceLabelChange="handleInvoiceLabelChange"/>
        <!-- 发票明细 -->
        <invoice-detail-table
        :ref="('invoiceDetailTable_'+ uuid)"
        :openInvoiceType="invoiceData.openInvoiceType"
        :jobId="invoiceData.jobId"
        :makeInvoiceStatus="invoiceData.makeInvoiceStatus"
        :invoiceLabel="invoiceLabel_"
        @saveSuccess="handleInvoiceDetailSave"
        @deleteSuccess="handleInvoiceDetailDelete"/>
        <!-- 发票内容 -->
        <invoice-content-table
        :ref="('invoiceContentTable_'+ uuid)"
        :openInvoiceType="invoiceData.openInvoiceType"
        :jobId="invoiceData.jobId"
        :makeInvoiceStatus="invoiceData.makeInvoiceStatus"
        :invoiceLabel="invoiceLabel_"
        :apApplyNo="invoiceData.apApplyNo"/>
    </div>
</template>

<script>
import InvoiceHeader from './InvoiceHeader';
import InvoiceDetailTable from './InvoiceDetailTable';
import InvoiceContentTable from './InvoiceContentTable';

export default {
    components: { InvoiceHeader, InvoiceDetailTable, InvoiceContentTable },
    props: {
        invoiceData: {
            type: Object
        },
        invoiceLabel: {
            type: String
        },
        uuid: {
            type: [String, Number],
            default: ''
        }
    },
    provide() {
        return {
            updateInvoice: this.updateInvoice
        };
    },
    data() {
        return {
            invoiceLabel_: '10'
        };
    },
    inject: ['updateInvoice'],
    methods: {
        // 发票明细保存成功
        handleInvoiceDetailSave() {
            // 更新发票金额
            this.updateInvoice(['amt', 'recVer', 'taxRate', 'fee', 'taxAmt']);
        },
        // 发票明细删除成功
        handleInvoiceDetailDelete() {
            // 更新发票金额
            this.updateInvoice(['amt', 'recVer', 'taxRate', 'fee', 'taxAmt']);
        },
        // 发票标签改变
        handleInvoiceLabelChange(label) {
            // 更新发票金额
            this.invoiceLabel_ = label;
        },
        // 获取发票详情
        getInvoiceDetailData() {
            return this.$refs['invoiceDetailTable_' + this.uuid].allTableData || [];
        },
        // 获取发票内容
        getInvoiceContentData() {
            return this.$refs['invoiceContentTable_' + this.uuid].allTableData || [];
        }

    },
    watch: {
        invoiceLabel: {
            immediate: true,
            handler(newValue) {
                this.invoiceLabel_ = newValue;
            }
        }
    },
    mounted() {
    }
};
</script>

<style lang="less" scoped>
/deep/ .el-card__header {
    padding: 10px 15px !important;
}
/deep/ .el-card__body {
    padding: 10px 15px !important;
}

</style>
